import { render, staticRenderFns } from "./HdsblcNew.vue?vue&type=template&id=2f6ce9f5&scoped=true"
import script from "./HdsblcNew.vue?vue&type=script&lang=js"
export * from "./HdsblcNew.vue?vue&type=script&lang=js"
import style0 from "./HdsblcNew.vue?vue&type=style&index=0&id=2f6ce9f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6ce9f5",
  null
  
)

export default component.exports